import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=785c65b6&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=785c65b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785c65b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('785c65b6')) {
      api.createRecord('785c65b6', component.options)
    } else {
      api.reload('785c65b6', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=785c65b6&scoped=true&", function () {
      api.rerender('785c65b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/AppMain.vue"
export default component.exports